import React, { useLayoutEffect } from 'react';

import { ErrorBoundary } from 'react-error-boundary';

import { PageNotFoundEmptyState } from '../empty-state';
import { I18nProvider } from '../i18n/I18nProvider';
import fetchTranslations from '../i18n/fetchTranslations';
import { usePerformanceMetrics } from '../performance-metrics/usePerformanceMetrics';
import { UniqueKeyProvider } from '../unique-key-provider/UniqueKeyProvider';
import { EditPage as Component, type EditPageProps as Props } from './EditPage';
export type EditPageProps = Props & { locale?: string };

// Do not place formatMessage / FormattedMessage / useIntl calls here outside of the I18nProvider.
// They will not function correctly due to a lack of I18n context.

export const EditPage = (props: EditPageProps): React.JSX.Element => {
	const { markIframeLoadMetrics } = usePerformanceMetrics();

	useLayoutEffect(() => {
		markIframeLoadMetrics('lazy-load-end');
		markIframeLoadMetrics('common-load-start');
	}, [markIframeLoadMetrics]);

	return (
		<I18nProvider locale={props.locale} fetchTranslations={fetchTranslations}>
			<UniqueKeyProvider>
				<ErrorBoundary fallback={<PageNotFoundEmptyState />}>
					<Component {...props} />
				</ErrorBoundary>
			</UniqueKeyProvider>
		</I18nProvider>
	);
};
